import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TopicvizService } from '@services/topicviz/topicviz.service';

@Component({
  selector: 'app-import-dataset',
  templateUrl: './import-dataset.component.html',
  styleUrls: ['./import-dataset.component.scss'],
})
export class ImportDatasetComponent {
  @Input() requestInProgress;
  @Output() requestInProgressChange = new EventEmitter<boolean>();
  public datasetName;
  public selectedDatasetFile;
  public options = {
    keywordExtractionAlgorithm: 'TEXTRANK',
    n_keywords: 3,
    find_pictures: true,
  };

  constructor(private topicVizDataLoader: TopicvizService) {}

  handleFileSelectDataset(evt) {
    const files = evt.target.files; // FileList object
    this.selectedDatasetFile = files[0];
    const fileName = files[0].name;
    this.datasetName = fileName
      .slice(0, fileName.length - 4)
      .replace(/[^\w\s]/gi, '');
  }

  setRequestInProgress(flag) {
    this.requestInProgressChange.emit(flag);
  }

  importDataset() {
    if (
      this.requestInProgress ||
      !this.selectedDatasetFile ||
      !this.datasetName
    ) {
      return;
    }

    const reader = new FileReader();
    reader.readAsText(this.selectedDatasetFile);
    reader.onload = (event: any) => {
      this.setRequestInProgress(true);
      this.topicVizDataLoader
        .importDataset(
          event.target.result,
          this.datasetName,
          this.options['keywordExtractionAlgorithm'],
          this.options['n_keywords'],
          this.options['find_pictures'],
        )
        .subscribe(
          () => {
            this.setRequestInProgress(false);
          },
          response => {
            alert(response.error['message'] || 'The import failed...');
            this.setRequestInProgress(false);
          },
        );
    };
  }
}
